<template>
  <div class="productList">
    <div class="product-title">
      <div class="title-left">{{ $t.shopping.productList }}</div>
      <div class="title-right" @click="handleSwitch">{{ $t.shopping.refresh }}</div>
    </div>
    <div class="product-content">
      <div
        class="product-content-item"
        v-for="(item, index) in productList"
        v-bind:key="index"
        @click="getProductDetails(item.BProductNumber, item.ShopId)"
      >
        <div class="product-content-item-img">
          <van-image :src="imgUrlFilter(item.ProductPhoto)">
            <template v-slot:error>
              <img class="ImgIcon" src="~assets/img/other/empty.gif" />
            </template>
          </van-image>
        </div>
        <div class="product-content-item-price">$ {{ item.CurrentPrice }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image } from "vant";
Vue.use(Image);

export default {
  name: "productList",
  props: ["productList", "pageIndex"],
  data() {
    return {};
  },
  methods: {
    handleSwitch() {
      this.$emit("handleSwitch", this.pageIndex + 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatVancheenUrl(value.split("|")[0]);
    },
    // 跳转详情页
    getProductDetails(BProductNumber, ShopId) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "details",
        name: "details",
        query: [
          {
            name: "ProductNumber",
            value: BProductNumber,
          },
          {
            name: "ShopId",
            value: ShopId,
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.productList {
  width: 95%;
  margin: auto;
  background: #f9fafd;
  border-radius: 20px;
  .product-title {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    align-items: center;
    .title-left {
      color: #000;
      font-size: 12px;
      font-weight: 500;
    }
    .title-right {
      color: #1a347b;
      font-size: 12px;
      font-weight: 500;
    }
  }
  .product-content {
    padding: 0% 1.5%;
    .product-content-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .van-image {
        width: 100px;
        height: 100px;
        object-fit: cover;
        -webkit-object-fit: cover;
        border-radius: 10px;
        .ImgIcon {
          width: 100px;
          height: 100px;
          object-fit: cover;
          -webkit-object-fit: cover;
          border-radius: 10px;
        }
        ::v-deep .van-image__img {
          width: 100px;
          height: 100px;
          object-fit: cover;
          -webkit-object-fit: cover;
          border-radius: 10px;
        }
        ::v-deep .van-image__error {
          width: 100px;
          height: 100px;
          object-fit: cover;
          -webkit-object-fit: cover;
          border-radius: 10px;
        }
      }
      .product-content-item-price {
        font-size: 14px;
        color: #ed6926;
        margin-top: 10px;
        margin-bottom: 15px;
        font-weight: bold;
      }
    }
  }
}
</style>
